import {
    Injectable
} from '@angular/core';
import {
    AlertController
} from '@ionic/angular';
import { AlertOptions } from '@ionic/core';
import { stringify } from 'querystring';

@Injectable({
    providedIn: 'root'
})
export class SopoAlertService {

    constructor(
        private alertController: AlertController,
    ) {}

    public async create(options: AlertOptions): Promise < HTMLIonAlertElement > {
        const sopoOptions: AlertOptions = {
            ...options,
            mode: 'md'
        };
        return this.alertController.create(sopoOptions);
    }

    public async alert(options: AlertOptions, dismissAfter = 2000): Promise <void> {
        return this.create(options).then((alert) => {
            alert.present();
            setTimeout(() => alert.dismiss(), dismissAfter);
        });
    }

    public async dismiss(data ?: any, role ?: string, id ?: string): Promise < boolean > {
        return this.alertController.dismiss(data, role, id);
    }

    public async getTop(): Promise < HTMLIonAlertElement | undefined> {
        return this.alertController.getTop();
    }

    async showAlert(header: string, message: string, timeout: number = 2000){
        const alert = await this.create({
            header: header,
            message: message,
        });
        await alert.present();
        setTimeout(() => alert.dismiss(), timeout);
    }
}
